import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=5315ed1c&scoped=true&"
import script from "./ArrowIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ArrowIcon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ArrowIcon.vue?vue&type=style&index=0&id=5315ed1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315ed1c",
  null
  
)

export default component.exports